"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PropertyDot = _interopRequireDefault(require("./PropertyDot"));

var _PropertyLabel = _interopRequireDefault(require("./PropertyLabel"));

var _BoundaryManager = require("../BoundaryManager/BoundaryManager");

var _PropertyPill = _interopRequireDefault(require("./PropertyPill"));

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/PropertyMarkers/PropertyMarker.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var PropertyMarker =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(PropertyMarker, _PureComponent);

  function PropertyMarker(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.startHover = _this.startHover.bind(_assertThisInitialized(_this));
    _this.endHover = _this.endHover.bind(_assertThisInitialized(_this));
    _this.onMarkerClick = _this.onMarkerClick.bind(_assertThisInitialized(_this));
    _this.mapDotTagType = "Plain";
    return _this;
  }

  var _proto = PropertyMarker.prototype;

  _proto.onMarkerClick = function onMarkerClick(e) {
    var _this$props = this.props,
        onMarkerClick = _this$props.onMarkerClick,
        markerId = _this$props.markerId,
        detailUrl = _this$props.detailUrl;

    if (onMarkerClick) {
      (0, _BoundaryManager.ignoreGoogleMapEvents)(); // Notify boundary manager to not handle parcel click on the same mouse event

      var eventData = {
        altKey: e.altKey,
        button: e.button,
        buttons: e.buttons,
        clientX: e.clientX,
        clientY: e.clientY,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        screenX: e.screenX,
        screenY: e.screenY,
        shiftKey: e.shiftKey
      };
      onMarkerClick(markerId, eventData, this.mapDotTagType);
    } else if (detailUrl) {
      window.location.href = detailUrl;
    }
  };

  _proto.endHover = function endHover() {
    if (this.hoverStarted) {
      this.hoverStarted = false;
      var onMapMarkerMouseLeave = this.props.onMapMarkerMouseLeave;

      if (onMapMarkerMouseLeave) {
        onMapMarkerMouseLeave();
      }
    }
  };

  _proto.startHover = function startHover(mouseEvent) {
    // Only respond to mouse hover if the mouse buttons are not down
    // This will prevent the hover from causing jank during map pan via mouse.
    if (mouseEvent.buttons === 0) {
      this.hoverStarted = true;
      var _this$props2 = this.props,
          onHoverStart = _this$props2.onHoverStart,
          markerId = _this$props2.markerId,
          onMapMarkerMouseEnter = _this$props2.onMapMarkerMouseEnter,
          clearHoveredMarkerId = _this$props2.clearHoveredMarkerId,
          zpid = _this$props2.zpid,
          buildingId = _this$props2.buildingId,
          latLong = _this$props2.latLong;

      if (onHoverStart) {
        if (markerId && clearHoveredMarkerId) {
          clearHoveredMarkerId();
        }

        if (onMapMarkerMouseEnter) {
          onMapMarkerMouseEnter(zpid || buildingId, latLong);
        }

        onHoverStart(markerId);
      }
    }
  };

  _proto.renderDot = function renderDot(elementProps, label) {
    var _this$props3 = this.props,
        isHovered = _this$props3.isHovered,
        statusType = _this$props3.statusType,
        showDot = _this$props3.showDot,
        overText = _this$props3.overText,
        favorite = _this$props3.favorite,
        visited = _this$props3.visited,
        isCommunityEdgeCase = _this$props3.isCommunityEdgeCase,
        notificationHighlight = _this$props3.notificationHighlight,
        zillowOwned = _this$props3.zillowOwned,
        disableOutline = _this$props3.disableOutline;
    return _react.default.createElement(_PropertyDot.default, _extends({
      showDot: showDot,
      statusType: statusType,
      isHovered: isHovered,
      overText: overText.length > 1 ? '9+' : overText,
      favorite: favorite,
      visited: visited,
      isCommunityEdgeCase: isCommunityEdgeCase,
      notificationHighlight: notificationHighlight,
      zillowOwned: zillowOwned,
      disableOutline: disableOutline
    }, elementProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 97
      },
      __self: this
    }), label);
  };

  _proto.renderLabel = function renderLabel(elementProps) {
    var lowZoomLabel = this.props.lowZoomLabel;
    var _this$props4 = this.props,
        alwaysShowLabel = _this$props4.alwaysShowLabel,
        favorite = _this$props4.favorite,
        has3DModel = _this$props4.has3DModel,
        is3DTourMapDotEnabled = _this$props4.is3DTourMapDotEnabled,
        isHovered = _this$props4.isHovered,
        isHighZoom = _this$props4.isHighZoom,
        markerLabel = _this$props4.markerLabel,
        notificationHighlight = _this$props4.notificationHighlight,
        renderAsPill = _this$props4.renderAsPill,
        showDot = _this$props4.showDot,
        statusType = _this$props4.statusType,
        visited = _this$props4.visited,
        isRMX3rdPartyTrial = _this$props4.isRMX3rdPartyTrial,
        isForYouHome = _this$props4.isForYouHome; // If always show label is enabled, and there isn't already a low zoom label
    // then display the 'normal' label also while low zoom.

    if (alwaysShowLabel && !lowZoomLabel) {
      lowZoomLabel = markerLabel;
    }

    var notificationClass = notificationHighlight ? ' notification-marker' : '';
    var propertyLabelClass = showDot ? 'streamlined-property-label' : 'streamlined-inverted-property-label';
    var isHoveredClass = isHovered ? ' is-hovered' : '';
    var isRoundedLabelClass = ' rounded';

    if (!notificationHighlight && isHighZoom) {
      if (isForYouHome) {
        this.mapDotTagType = "ForYou";
      } else if (is3DTourMapDotEnabled && has3DModel) {
        this.mapDotTagType = "3DTour";
      }
    } else {
      this.mapDotTagType = "Plain";
    }

    if (renderAsPill) {
      var pillLabelClassNames = "" + notificationClass + isHoveredClass;
      return _react.default.createElement(_PropertyPill.default, _extends({
        markerLabel: isHighZoom ? markerLabel : lowZoomLabel,
        showDot: showDot,
        labelClassNames: pillLabelClassNames,
        favorite: favorite,
        visited: visited
      }, elementProps, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 161
        },
        __self: this
      }));
    }

    var labelClassNames = "" + propertyLabelClass + notificationClass + isHoveredClass + isRoundedLabelClass;
    return _react.default.createElement(_PropertyLabel.default, _extends({
      markerLabel: isHighZoom ? markerLabel : lowZoomLabel,
      showDot: showDot,
      labelClassNames: labelClassNames,
      show3DHomeLabel: is3DTourMapDotEnabled && has3DModel && !notificationHighlight && isHighZoom && !isForYouHome,
      showForYouLabel: isForYouHome && !notificationHighlight && isHighZoom,
      statusType: statusType,
      isRMX3rdPartyTrial: isRMX3rdPartyTrial
    }, elementProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 170
      },
      __self: this
    }));
  };

  _proto.render = function render() {
    var renderAsPill = this.props.renderAsPill;
    var showDot = this.props.showDot && !renderAsPill;
    var elementProps = {
      className: "streamlined-marker-container streamlined-marker-position " + (showDot ? 'streamlined-property-dot' : ''),
      style: {
        transform: this.props.transformStyle,
        zIndex: this.props.zIndex
      },
      role: 'link',
      tabIndex: '-1',
      onMouseEnter: this.startHover,
      onMouseLeave: this.endHover,
      onClick: this.onMarkerClick
    };

    if (showDot) {
      return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        this.renderDot(elementProps, this.renderLabel())
      );
    }

    return this.renderLabel(elementProps);
  };

  return PropertyMarker;
}(_react.PureComponent);

PropertyMarker.propTypes = process.env.NODE_ENV !== "production" ? {
  zIndex: _propTypes.default.number,
  transformStyle: _propTypes.default.string,
  isCommunityEdgeCase: _propTypes.default.bool,
  statusType: _propTypes.default.string,
  showDot: _propTypes.default.bool,
  markerLabel: _propTypes.default.string,
  onHoverStart: _propTypes.default.func,
  onMapMarkerMouseLeave: _propTypes.default.func,
  onMapMarkerMouseEnter: _propTypes.default.func,
  clearHoveredMarkerId: _propTypes.default.func,
  markerId: _propTypes.default.string,
  isHovered: _propTypes.default.bool,
  onMarkerClick: _propTypes.default.func,
  northSouthLat: _propTypes.default.number,
  eastWestLng: _propTypes.default.number,
  alwaysShowLabel: _propTypes.default.bool,
  notificationHighlight: _propTypes.default.bool,
  overText: _propTypes.default.string,
  lowZoomLabel: _propTypes.default.string,
  favorite: _propTypes.default.bool,
  visited: _propTypes.default.bool,
  zillowOwned: _propTypes.default.bool,
  detailUrl: _propTypes.default.string,
  zpid: _propTypes.default.string,
  buildingId: _propTypes.default.string,
  latLong: _propTypes.default.object,
  isHighZoom: _propTypes.default.bool,
  renderAsPill: _propTypes.default.bool,
  has3DModel: _propTypes.default.bool,
  is3DTourMapDotEnabled: _propTypes.default.bool,
  isRMX3rdPartyTrial: _propTypes.default.bool,
  isForYouHome: _propTypes.default.bool,
  disableOutline: _propTypes.default.bool
} : {};
PropertyMarker.defaultProps = {
  // isCommunityEdgeCase is a temp workaround for responsive desktop turn up
  // under a very specific case
  // it should not be reused and is here to display For_Sale dot colors
  zIndex: null,
  transformStyle: '',
  isCommunityEdgeCase: false,
  statusType: '',
  showDot: false,
  markerLabel: '',
  onHoverStart: function onHoverStart() {
    return null;
  },
  onMapMarkerMouseLeave: function onMapMarkerMouseLeave() {
    return null;
  },
  onMapMarkerMouseEnter: function onMapMarkerMouseEnter() {
    return null;
  },
  clearHoveredMarkerId: function clearHoveredMarkerId() {
    return null;
  },
  markerId: '',
  isHovered: false,
  onMarkerClick: function onMarkerClick() {
    return null;
  },
  northSouthLat: null,
  eastWestLng: null,
  alwaysShowLabel: false,
  notificationHighlight: false,
  overText: '',
  lowZoomLabel: '',
  favorite: false,
  visited: false,
  zillowOwned: false,
  detailUrl: '',
  zpid: null,
  buildingId: null,
  latLong: null,
  isHighZoom: false,
  renderAsPill: false,
  has3DModel: false,
  is3DTourMapDotEnabled: false,
  isRMX3rdPartyTrial: false,
  isForYouHome: false,
  disableOutline: false
};
var _default = PropertyMarker;
exports.default = _default;